import { useNavigation } from '@react-navigation/native';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { confirmCreateSalesOrderData } from 'states/common';
import { usePermitStore } from 'stores/permitStore';
import { useReactiveVar } from '@apollo/client';
import { RootNavProps } from 'types/navigation';
import { useUiStore } from 'stores/uiStore';

export const useUnlockPmc = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();

  const selectedPmcValue = usePermitStore((state) => state.selectedPmc);
  const pmcId = selectedPmcValue?.pmcId;
  const parkingZoneUid = selectedPmcValue?.parkZone?.uid ?? '';

  const [unlockCode, setUnlockCode] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const existingConfirmData = useReactiveVar(confirmCreateSalesOrderData);

  const handleInputChange = useCallback(
    (text: string) => {
      setErrorMessage(null);
      setUnlockCode(text);
      if (!text) {
        confirmCreateSalesOrderData({
          ...existingConfirmData,
          unlockCode: undefined,
          startDate: existingConfirmData?.startDate ?? new Date(),
        });
      }
    },
    [existingConfirmData]
  );

  const handleCancel = useCallback(() => {
    useUiStore.getState().setSheetModal('');
  }, []);

  const handleSuccess = useCallback(
    (includeUnlockCodeInConfirmData: boolean = false) => {
      if (pmcId) {
        confirmCreateSalesOrderData({
          ...existingConfirmData,
          unlockCode: includeUnlockCodeInConfirmData ? unlockCode : undefined,
          startDate: existingConfirmData?.startDate ?? new Date(),
        });

        useUiStore.getState().setSheetModal('');

        navigate('longTermParking', {
          screen: 'buyScreen',
          params: { pmcId, parkingZoneUid },
        });
      }
    },
    [existingConfirmData, navigate, parkingZoneUid, pmcId, unlockCode]
  );

  return {
    t,
    pmcId,
    parkingZoneUid,
    unlockCode,
    setUnlockCode,
    errorMessage,
    setErrorMessage,
    handleInputChange,
    handleCancel,
    handleSuccess,
  };
};
